
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statics/[static]",
      function () {
        return require("private-next-pages/statics/[static].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statics/[static]"])
      });
    }
  